<fui-rows [label]="label">
  <fui-content-layout-header-control slot="after">
    @if (!editing && model.canEdit(true)) {
      <fui-link-button [title]="'edit'"
      (click)="edit()"></fui-link-button>
    }
  </fui-content-layout-header-control>

  @if (data && formGroupContact) {
    <fui-row [formGroup]="formGroupContact">
      <fui-two-columns>
        <fui-column>
          <fui-text-control
            formControlName="firstName"
            [control]="formGroupContact.get('firstName')"
            [label]="'fhm.contact.firstName'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
          [(ngModel)]="data.firstName"></fui-text-control>
        </fui-column>
        <fui-column>
          <fui-text-control
            formControlName="lastName"
            [control]="formGroupContact.get('lastName')"
            [label]="'fhm.contact.lastName'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
          [(ngModel)]="data.lastName"></fui-text-control>
        </fui-column>
      </fui-two-columns>
    </fui-row>
    <fui-row [formGroup]="formGroupContact">
      <fui-two-columns>
        <fui-column>
          <fui-text-control
            formControlName="email"
            [control]="formGroupContact.get('email')"
            [label]="'fhm.contact.email'"
            [placeholder]="'fhm.common.label.no-label'"
            [disabled]="!editing"
          [(ngModel)]="data.email"></fui-text-control>
        </fui-column>
        <fui-column>
          <fui-text-control
            [label]="'fhm.contact.mobile'"
            [placeholder]="'fhm.common.label.no-label'"
            [ngModelOptions]="{standalone: true}"
            [disabled]="!editing"
          [(ngModel)]="data.mobile"></fui-text-control>
        </fui-column>
      </fui-two-columns>
    </fui-row>
    @if (editing && !model.draft) {
      <fui-row>
        <fhm-action-buttons>
          @if (!newEntity) {
            <fhm-remove-button [title]="'fhm.common.button.cancel'"
            (clicked)="cancelEdit()"></fhm-remove-button>
          }
          <fhm-provision-button [title]="!newEntity ? 'fhm.common.button.save' : 'fhm.common.button.create'"
          (clicked)="save()"></fhm-provision-button>
        </fhm-action-buttons>
      </fui-row>
    }
  }
</fui-rows>


